import { debounce } from '@cian/ui-kit/internal/utils';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getSubAgents, setSubAgentsSearch } from '../../actions/subAgents';
import { SubAgentSearchInput } from '../../components/SubAgentSearchInput/SubAgentSearchInput';
import { subAgentsSelector } from '../../selectors';
import { ERequestApiStatus } from '../../types/appState';

export const SubAgentSearchInputContainer = () => {
  const { status, search } = useSelector(subAgentsSelector);

  const [inputValue, setInputValue] = React.useState(search || '');

  const dispatch = useDispatch();

  const isLoading = status === ERequestApiStatus.Pending;

  const handleSearch = React.useCallback(
    (search: string) => {
      dispatch(getSubAgents({ search }));
      dispatch(setSubAgentsSearch({ search }));
    },
    [dispatch],
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceFn = React.useCallback(debounce(handleSearch, 1000), []);

  const handleChangeInput = React.useCallback(
    (value: string) => {
      setInputValue(value);
      debounceFn(value);
    },
    [debounceFn],
  );

  return <SubAgentSearchInput value={inputValue} onChange={handleChangeInput} isLoading={isLoading} />;
};
